<template>
<div>



<div class="contenttopbar grid px-3 mt-1">
<div class="col-10 md:col-9">
<h3 class="text-primary mb-3 mt-3 font-medium">{{$store.state.languages.lang_phrases.marka_raporu}}</h3>
</div>

<div class="col-2 md:col-3">
<div class="flex align-items-center justify-content-end">
<div class="hide_on_mobile "><Button type="button" :class="'p-button-danger p-button-outlined p-button-sm mt-2'" :label="$store.state.languages.lang_phrases.geri_don" icon='pi pi-arrow-left' @click="goToUrl" /></div>
<div class="show_on_mobile"><Button type="button" :class="'p-button-danger p-button-outlined p-button-sm mt-2'" icon='pi pi-arrow-left' @click="goToUrl" /></div>
</div>
</div>
</div>




<div class="mt-4">

<span class="p-float-label mb-4 mt-0" >
  <InputText id="calculation_name" type="text" v-model="item.name" class="w-full p-inputtext-sm" :class="{'p-invalid':has_error }" @input="removeError"  />
  <label for="calculation_name"  :class="{'hidden':has_error }">İsim</label>
  <small id="calculation_name-help" class="p-error pt-2" v-if="has_error"> İsim gerekli</small>
</span>



<template v-if="$route.params.report_id">
<h4>Çeviriler</h4>
<template v-if="!adding_translation">
<Button icon='pi pi-plus'   class="p-button-outlined p-button-sm p-button-primary"  @click="addNewTranslation"></Button>
</template>


<template v-if="adding_translation">
<div class="grid">
<div class="col-7">
<InputText  type="text" v-model="new_translation.translation" class="w-full p-inputtext-sm"  placeholder="Çeviri isim"  />
</div>

<div class="col-3">
<Dropdown :filter="true"  v-model="new_translation.language_id" :options="languages" optionLabel="name" optionValue="id" class="w-full p-inputtext-sm"/>
</div>

<div class="col-2">
<Button icon='pi pi-check'   class="p-button-outlined p-button-sm p-button-primary" :loading="$store.state.ui.submitting" @click="submitNewTranslation"></Button>
<Button icon='pi pi-times'   class="p-button-outlined p-button-sm p-button-danger ml-2" :loading="$store.state.ui.submitting" @click="cancelAddNewTranslation"></Button>
</div>
</div>
</template>

<div v-for="translation of item.translations">
<ClickEditInputText  :title="translation.language.name" :value="translation.translation" :valkey="translation.id" @dataChanged="translationChanged" />
</div> 
</template>






<AnalyticsCalculationRoot :nodesdata="item.theschema" ></AnalyticsCalculationRoot>



</div>

<div class="flex align-items-center justify-content-end mb-6 mt-4">

<Button label="Kaydet"  class="p-button-outlined p-button-sm p-button-primary" :loading="$store.state.ui.submitting" type="submit" @click="submit"></Button>
</div>

</div>	
</template>

<script>
export default {

  name: 'BrandReportEdit',

  data () {
    return {
      loading:true,
      languages:[],
      adding_translation:false,
      new_translation:{
        translation:null,
        language_id:null,
      },
      item:{
        id:null,
        name:null,
        theschema:null,
        translations:[],
      },
      booleanoptions:[
      {name:"Açık",id:1},
      {name:"Kapalı",id:0},
      ],
      has_error:false,
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    translationChanged(data)
    {
      
      if(this.$route.params.report_id)
      {
        let formdata = new FormData()
        formdata.append('data', JSON.stringify(data));
        this.generalSubmission(formdata,"brand_report/update_translation/"+data.key,this.afterTranslationUpdated)
      }
    },
    afterTranslationUpdated(response)
    {
      this.item.translations = response.data.translations
      this.cancelAddNewTranslation()
    },
    addNewTranslation()
    {
      this.adding_translation = true
    },
    cancelAddNewTranslation()
    {
      this.new_translation = {
          translation:null,
          language_id:null,
        }
        this.adding_translation = false
    },
    submitNewTranslation()
    {
      let prev_translation = this.item.translations.find((item)=>{return item.language_id == this.new_translation.language_id})
      if(prev_translation)
      {
        this.showMessage("error","Bu dil için bir çeviri mevcut")
        this.cancelAddNewTranslation()
        return false
      }
      if(this.$route.params.report_id)
      {
        let formdata = new FormData()
        formdata.append('data', JSON.stringify(this.new_translation));
        this.generalSubmission(formdata,"brand_report/submit_translation/"+this.$route.params.report_id,this.afterTranslationUpdated)
      }
      else
      {
        this.item.translations.push(this.new_translation)
        setTimeout(()=>{
          this.cancelAddNewTranslation()
        })
      }
      
    },
    goToUrl()
    {      
      console.log("goToUrl")
      if(this.$route.params.report_id)
      {
        console.log("BrandReport")
        this.$router.push({ name: "BrandReport"}) 
      }
      else
      {
        console.log("BrandReports")
        this.$router.push({ name: "BrandReports"})
      }
      
    },
    removeError()
    {
      this.has_error = false
    },
    async getData()
    {
      this.loading = await true
      this.languages = await this.generalApiGetWithoutLoader("languages") 
      console.log(this.languages)
      if(this.$route.params.report_id)
      {
        this.item = await this.generalApiGetWithoutLoader("brand_report/"+this.$route.params.report_id)  
        console.log("item")      
        console.log(this.item)
      }
      
      this.loading = await false
    },
    submit()
    {
      if(!this.item.name || this.item.name=="")
      {
        this.has_error = true
        return false
      }

      console.log(this.item)
      console.log(this.$store.state.calculations.nodes)
      //return false
        let formdata = new FormData()
        formdata.append('brand_id', this.$route.params.id);
        formdata.append('name', this.item.name);
        let nodes = this.$store.state.calculations.nodes
        let connections = this.$store.state.calculations.connections
        let theschema = {nodes:nodes,connections:connections}
        formdata.append("theschema",JSON.stringify(theschema)) 
        if(this.$route.params.report_id)
        {
          console.log("update")
          this.generalSubmission(formdata,"brand_report/"+this.$route.params.report_id,this.afterSubmit)
        }
        else
        {
          this.generalSubmission(formdata,"brand_reports/"+this.$route.params.id,this.afterSubmit)
        }
        
    },
    afterSubmit(response)
    {
        console.log(response.data);
        //this.$router.push({ name: 'QuestionlistSameTypeCalculations' })
       
          
    },
  }
}
</script>

<style lang="css" scoped>
</style>